'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var nthHookTheme = require('@narvar/nth-hook-theme');
var paths = require('./paths.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Svg = styled.svg.withConfig({
  componentId: "sc-1urdolp-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    width: '3rem',
    height: 'auto',
    fill: s && s.color || '#000',
    verticalAlign: 'middle'
  }, s);
});
var CheckMarkIcon = function CheckMarkIcon() {
  var _useTheme = nthHookTheme.useTheme(),
    checkMarkIconStyle = _useTheme.iconsPrimaryNone;
  return /*#__PURE__*/React.createElement(Svg, {
    s: checkMarkIconStyle,
    viewBox: "0 0 48 48",
    role: "img"
  }, /*#__PURE__*/React.createElement("path", {
    d: paths.default
  }));
};
var index = nthHookTheme.withThemeProvider(CheckMarkIcon, {
  themeTokens: ['iconsPrimaryNone']
});

exports.default = index;
